import React from "react";

import VideoOverlay from "../../components/Shared/VideoOverlay";
import Container from "../../components/Shared/Container";
import Video from "../../components/Shared/Video";

import BLOOPERS from '../../assets/movies/bloopers.mp4';

import { useHistory } from "react-router";

const BloopersView = () => {
	const history = useHistory();

	return (
		<Container>
			<Video
				visible
				autoPlay={'autoplay'}
				onEnded={() => history.push('/')}
			>
				<source src={BLOOPERS} type="video/mp4"/>
			</Video>
			<VideoOverlay/>
		</Container>
	)
};

export default BloopersView;